import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    // 手机号登录
    {
      path: '/login',
      component: () => import('@/views/Login.vue')
    },
    // 注册
    {
      path: '/register',
      component: () => import('@/views/register.vue')
    },
    /* // 忘记密码
    {
      path: '/forgetpwd',
      component: () => import('@/views/ForgetPwd.vue')
    }, */

    //绑定手机号
    {
      path: '/phone',
      component: () => import('@/views/phone.vue')
    },
    /* //商品详情
    {
      path: '/',
      component: () => import('@/views/GoodsDetail.vue')
    }, */



    //商品详情
    {
      path: '/',
      component: () => import('@/views/ship.vue')
    },



    //店铺首页
    {
      path: '/store',
      component: () => import('@/views/store.vue')
    },
    //协议说明
    {
      path: '/agreement',
      component: () => import('@/views/agreement.vue')
    },
    //商品列表
    {
      path: '/goodslist',
      component: () => import('@/views/GoodsList.vue')
    },
    //我的订单
    {
      path: '/myorderlist',
      component: () => import('@/views/myOrderList.vue')
    },
    //订单详情
    {
      path: '/orderdetails',
      component: () => import('@/views/orderDetails.vue')
    },
    //订单物流
    {
      path: '/orderLogistics',
      component: () => import('@/views/orderLogistics.vue')
    },
    //个人中心
    {
      path: '/personalcenter',
      component: () => import('@/views/personalCenter.vue')
    },
    //设置昵称
    {
      name: 'nickname',
      path: '/nickname',
      component: () => import('@/views/nickName.vue')
    },
    //支付成功
    {
      path: '/paysuccess',
      component: () => import('@/views/paySuccess.vue')
    },
    //收货地址
    {
      path: '/shippingaddress',
      component: () => import('@/views/shippingAddress.vue')
    },
    //新增/编辑收货地址
    {
      name: 'compileaddress',
      path: '/compileaddress',
      component: () => import('@/views/compileAddress.vue')
    },
    //确认订单
    {
      path: '/affirmorder',
      component: () => import('@/views/affirmOrder.vue')
    },
    //订单支付
    {
      path: '/toorderpay',
      component: () => import('@/views/toOrderPay.vue')
    },
    
    

















    //demo
    {
      path: '/demo',
      component: () => import('@/views/demo.vue')
    },
  ]
})
